/* eslint-disable react/no-unescaped-entities */
import { Link } from "gatsby";
import * as React from "react";
import ReactGA from "react-ga";
import freeBanner from "src/assets/img/education/free-banner.png";
import expCl from "src/assets/img/free-courses/clinicians-exploring.jpg";
import expPsy from "src/assets/img/free-courses/exploring.jpg";
import freeCourseSeo from "src/assets/img/free-courses/free-course-seo.jpg";
import freeCourse from "src/assets/img/free-courses/free-course.png";
import harmReduction from "src/assets/img/free-courses/harmReduction.jpg";
import journeyIntegration from "src/assets/img/free-courses/journey-integration.jpg";
import littleBook from "src/assets/img/free-courses/little-book.jpg";
import PsImg from "src/components/General/Image";
import SEO from "src/components/General/SEO";
import pixel from "src/services/facebookPixel";
// reactstrap components
import { Button, Col, Container, Row } from "reactstrap";
import { SubscribeFreeCourses } from "src/components/Pages/Education/FreeCourses/SubscribeFreeCourses";

interface FreeCoursesPageProps {
  cropAndPersistImage: any;
  data: {
    site: {
      siteMetadata: {
        name: string;
        tagline: string;
      };
    };
  };
}
interface FreeCoursesState {
  success: boolean;
}

// eslint-disable-next-line import/no-default-export
export default class FreeCoursesPage extends React.Component<FreeCoursesPageProps, FreeCoursesState> {
  constructor(props: FreeCoursesPageProps) {
    super(props);
    this.state = {
      success: false,
    };
    this.success = this.success.bind(this);
  }

  private success(interests: string[]): void {
    // facebook event
    // eslint-disable-next-line @typescript-eslint/naming-convention
    pixel.event("track", "CompleteRegistration", { content_name: "free-courses" });
    // GA event
    ReactGA.event({
      category: "funnel",
      action: "registration",
      label: "free-courses",
    });
    interests.forEach((i) => {
      ReactGA.event({
        category: "registration",
        action: "interest",
        label: i,
      });
      pixel.event("trackCustom", `${i}`);
    });
    this.setState({
      success: true,
    });
  }

  // tslint:disable-next-line:max-line-length
  public render() {
    return (
      <div className="free-courses">
        <SEO
          title={"Get FREE access to our Psychedelic Courses"}
          image={freeCourseSeo}
          description={
            "The most important education you didn’t get in school. Sign up now for free access to our Exploring Psychedelics and Harm Reduction courses!"
          }
          pathname="/education/free-courses/"
        />
        <div className="leader">
          <Container>
            <Row>
              <Col lg="6 text-center pt-5 pb-5">
                <img className="img-fluid" src={freeCourse} alt="Free Psychedelic Education from Psychedelic Support" />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="support">
          <Container>
            <Row className="pt-5 pb-5">
              <Col lg={{ size: 6, order: 1 }} xs={{ size: 12, order: 2 }}>
                <h5 className="cta fw600">The Most Important Education You Didn’t Get In School.</h5>
                <p>
                  You probably didn’t learn much in your formal education about therapeutic applications for
                  psychedelics or how to reduce risks.
                </p>
                <p className="fw600">Start your learning journey now!</p>
                <ul>
                  <li>
                    Subscribe to our newsletter to get the latest evidence-backed information delivered to your inbox.
                  </li>
                  <li>
                    Advance your understanding of psychedelic-assisted therapies in our accredited online courses and
                    training programs. <Link to="/education/">Earn continuing education (CE/CME) credits</Link>.
                  </li>
                  <li>
                    Join the discussion and meet others in our live monthly{" "}
                    <Link to="/monthly-speaker-professional-networking/">
                      Speaker and Professional Networking Series
                    </Link>
                    .
                  </li>
                </ul>
              </Col>
              <Col className="cta-box p-4" lg={{ size: 6, order: 2 }} xs={{ size: 12, order: 1 }}>
                <h1 className=" mt-0">Free courses.</h1>
                <h2 className="cta mt-3 mb-3">
                  Experts in harm reduction and psychedelic therapy want you to be informed!
                </h2>
                <SubscribeFreeCourses successCb={(interests): void => this.success(interests)} />
                {this.state.success === true && (
                  <div className="success mt-3">
                    <p>
                      <b className="fw600">Excellent!</b> We've sent a welcome email with the course links and other
                      helpful info.
                    </p>
                    <i className="fw500">Click the links to get started now:</i>
                    <p>
                      <a
                        href="https://offers.psychedelic.support/riding-the-wave-psychedelic-harm-reduction-course/"
                        className="success-link"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Riding the Wave: Principles of Psychedelic Harm Reduction Course
                      </a>
                    </p>
                    <p>
                      <a
                        href="https://offers.psychedelic.support/exploring-psychedelics-course/"
                        className="success-link"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Exploring Psychedelics: Discovery, Research & Effects Course
                      </a>
                    </p>
                    <p>
                      <a
                        href="https://offers.psychedelic.support/clinicians-exploring-psychedelic-therapy-course/"
                        className="success-link"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Clinicians Exploring Psychedelic Therapy (3 CE Hours)
                      </a>
                    </p>
                    <p>
                      <a
                        href="https://offers.psychedelic.support/integration-journeyers-perspective/"
                        className="success-link"
                        target="_blank"
                        rel="noreferrer"
                      >
                        A Journeyer's Perspective for Clinicians (2 CE hours)
                      </a>
                    </p>
                    <p>
                      <a
                        href="https://offers.psychedelic.support/The-Little-Book-Psychedelic-Substances.pdf"
                        className="success-link"
                        target="_blank"
                        rel="noreferrer"
                      >
                        The Little Book of Psychedelic Substances
                      </a>
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        <Container className="mt-5 mb-5">
          <Row>
            <Col>
              {" "}
              <h4 className="cta fw600">Sign up now and get access to:</h4>
            </Col>
          </Row>
          <Row className="course">
            <Col lg="4" md="5" className="position-relative">
              <div className="cimg-wrapper">
                <PsImg src={littleBook} alt="The Little Book of Psychedelic Substances" />
              </div>
              <img className="free-banner" src={freeBanner} alt="free course!" />
            </Col>
            <Col lg="8" md="7">
              <h4 className="mt-2">The Little Book of Psychedelic Substances</h4>
              <div className="mt-3">
                <p>
                  Take a look at our practical guide on the 8 most popular psychedelic substances. This 45 page book on
                  psychedelic effects, doses, safety in medical and recreational settings, therapeutic overviews and
                  much more is FREE to download. Keep this book handy for all of your psychedelic explorations.
                </p>
                <i>Covers:</i>
                <ol>
                  <li>Psilocybin, MDMA, Ketamine, Esketamine, Ayahuasca, 5-Meo-DMT, LSD, Cannabis, Ibogaine</li>
                  <li>Psychedelic effects, doses, safety, therapeutics, and more</li>
                </ol>
              </div>
            </Col>
          </Row>
          <Row className="course">
            <Col lg="4" md="5" className="position-relative">
              <div className="cimg-wrapper">
                <PsImg src={expPsy} alt="Exploring Psychedelics: Discovery, Research & Effects" />
              </div>
              <img className="free-banner" src={freeBanner} alt="free course!" />
            </Col>
            <Col lg="8" md="7">
              <h4 className="mt-2">Exploring Psychedelics: Discovery, Research & Effects</h4>
              <div className="mt-3">
                <p>
                  Start with the basics and grow your proficiency of psychedelic terms and history in our FREE
                  introductory course. We’ll break down common myths with science-backed facts and take a look at how
                  research is advancing innovative psychedelic treatments.
                </p>
                <i>Course Objectives:</i>
                <ol>
                  <li>Describe psychedelic terminology through various characterizations.</li>
                  <li>Discuss cultural and historical uses of plant medicines and current psychedelic research.</li>
                  <li>List the range of disciplines where psychedelic research is applicable.</li>
                </ol>
              </div>
            </Col>
          </Row>
          <Row className="course">
            <Col lg="4" md="5" className="position-relative">
              <div className="cimg-wrapper">
                <PsImg src={expCl} alt="Clinicians Exploring Psychedelic Therapy" />
              </div>
              <img className="free-banner" src={freeBanner} alt="free course!" />
            </Col>
            <Col lg="8" md="7">
              <h4 className="mt-2">Clinicians Exploring Psychedelic Therapy (3 CE hours)</h4>
              <div className="mt-3">
                <p>
                  This course includes everything in the course above plus topics specific for mental healthcare
                  providers. Learn the fundamentals of psychedelic-assisted therapies and hear what’s next for this
                  flourishing field. You’ll hear from therapists on harm reduction, psychedelic applications for mental
                  health, cultural considerations, and integration techniques. Health professionals earn 3 hours of
                  continuing education (CE) credit.
                </p>
                <i>Course Objectives:</i>
                <ol>
                  <li>
                    Describe psychedelic terminology, the cultural and historical uses of plant medicines, and current
                    psychedelic research.
                  </li>
                  <li>Recite the effects, doses, and risks of 8 common psychedelic substances.</li>
                  <li>List the range of disciplines where psychedelic research is applicable.</li>
                  <li>Discuss culturally sensitive practices for psychedelic research and clinical practice.</li>
                </ol>
              </div>
            </Col>
          </Row>
          <Row className="course">
            <Col lg="4" md="5" className="position-relative">
              <div className="cimg-wrapper">
                <PsImg src={journeyIntegration} alt="A Journeyer's Perspective for Clinicians" />
              </div>
              <img className="free-banner" src={freeBanner} alt="free course!" />
            </Col>
            <Col lg="8" md="7">
              <h4 className="mt-2">A Journeyer's Perspective for Clinicians (2 CE hours)</h4>
              <div className="mt-3">
                <p>
                  Are you a clinician looking to dive into the groundbreaking world of psychedelic medicine? Ready to
                  make a profound impact on your clients' healing, self-discovery, and personal growth journeys? Look no
                  further – our FREE continuing education course will teach you how to create a safe and nurturing
                  environment for your clients to integrate psychedelic experiences while staying informed about
                  evolving legal and ethical standards.
                </p>
                <i>Course Objectives:</i>
                <ol>
                  <li>Describe how clinicians can support clients after psychedelic journeys.</li>
                  <li>Explain best practices for psychedelic integration.</li>
                  <li>
                    Demonstrate an understanding of the legal landscape of psychedelic medicine that is relevant for
                    clinicians.
                  </li>
                </ol>
              </div>
            </Col>
          </Row>
          <Row className="course">
            <Col lg="4" md="5" className="position-relative">
              <div className="cimg-wrapper">
                <PsImg
                  src={harmReduction}
                  alt="Strategies to Strengthen the Safe and Responsible Use of Psychedelics"
                />
              </div>
              <img className="free-banner" src={freeBanner} alt="free course!" />
            </Col>
            <Col lg="8" md="7">
              <h4 className="mt-2">Riding the Wave: Principles of Psychedelic Harm Reduction</h4>
              <div className="mt-3">
                <p>
                  Considering taking a psychedelic substance? Take our FREE harm reduction course to learn what to
                  expect and how to maximize safety. You’ll hear tips for best practices and integration, and ways to
                  get support after a challenging experience.
                </p>
                <i>Course Objectives:</i>
                <ol>
                  <li>
                    Describe the principles of harm reduction and define terminology related to psychedelic harm
                    reduction.
                  </li>
                  <li>
                    Understand risks and potential adverse consequences of psychedelic use and how risks vary across
                    settings and individuals.
                  </li>
                  <li>
                    Discuss harm reduction strategies and how preparation and integration can help mitigate risks.
                  </li>
                </ol>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="testimonials">
          <Container>
            <Row>
              <Col className="pt-5 pb-5 text-center">
                <h3 className="cta fw600 mb-3">
                  Ready to deepen your knowledge?
                  <br />
                  Check out our full educational offerings.
                </h3>
                <Link to="/education/">
                  <Button color="primary">Start now</Button>
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}
